import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import PopupTypes from '../../../customer_center/popup_types'
import SwitchFilterSimGolf from '../../../customer_center/components/sim_golf/filters/switch_filter_sim_golf'

const SimTableCardHelper = ({
  golfHub,
  openRegistrationData,
  selectedDropdownOption,
  registrationTitle,
  setRegistrationOpen,
  openPopup,
  id,
}) => {
  return (
    <span className='sim_table_card_helper'>
      { golfHub ?
        openRegistrationData.hasOpenRegistration ?
          <span className='registration_cell_container'>
            <SwitchFilterSimGolf
              switchFor='openRegistration'
              isChecked={ selectedDropdownOption.openRegistrationStatus === 'open' || registrationTitle != '' }
              setIsChecked={ setRegistrationOpen }
              openPopup={ openPopup }
              popupTypes={ PopupTypes.EXISTING_TIMES }
              selectedDropdownOption= { selectedDropdownOption }
              openRegistrationData={ openRegistrationData }
              checkedSuffix={
                `${window.I18n.t('customer_center_comp.components.table_headers.registration')}: 
                ${window.I18n.t('customer_center_comp.components.sim_golf_labels.open')}`
              }
              uncheckedSuffix={
                `${window.I18n.t('customer_center_comp.components.table_headers.registration')}: 
                ${window.I18n.t('customer_center_comp.components.sim_golf_labels.closed')}`
              }
            />
          </span> :
          <a className='registration_setup_link' href={`/leagues/${ id }/edit_registration_form?source=default_reg_settings`}>
            { window.I18n.t('customer_center_comp.components.sim_golf_buttons.set_up_registration') }
          </a> :
        <a className='golf_hub_setup_link' href={`/leagues/${ id }/setup_golfhub_data`}>
          { window.I18n.t('customer_center_comp.components.sim_golf_buttons.set_up_event_page') }
        </a>
      }
    </span>
  )
}

SimTableCardHelper.propTypes = {
  golfHub: PropTypes.string.isRequired,
  openRegistrationData: PropTypes.object.isRequired,
  selectedDropdownOption: PropTypes.object.isRequired,
  registrationTitle: PropTypes.string.isRequired,
  setRegistrationOpen: PropTypes.func.isRequired,
  openPopup: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
}

export default SimTableCardHelper